import { FaultData } from "@fairfleet/geotab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import formatDuration from "../../cells/formatDuration";
import FaultTable from "./FaultTable";
import AddInIds from "@/constants/AddInIds";
import { FAULT_DETAIL_HISTORY } from "@/constants/LookbackWindows";
import { useAddinData } from "@/hooks/addins/useAddinData";
import { useDiagnosticsByIds } from "@/hooks/diagnostic/useDiagnosticsByIds";
import { useFaultDataByDiagnosticId } from "@/hooks/faultData/useFaultDataByDiagnosticId";
import { DiagnosticAddinData } from "@/pages/diagnostic-edit/models/DiagnosticAddinData";
import { resolveDiagnosticOverride } from "@/pages/diagnostic-edit/utils/resolveDiagnosticOverride";

export const FaultDetail = (props: { event: FaultData; deviceGroupIds?: string[] }) => {
  const { event, deviceGroupIds = [] } = props;
  const { t } = useTranslation();
  const { data: descriptions = [] } = useAddinData<DiagnosticAddinData>(AddInIds.diagnosticData);
  const dId = event?.diagnostic?.id;
  const { data: diagnostics = {} } = useDiagnosticsByIds([dId]);
  const diagnostic = diagnostics[dId];
  const { data: lastFaults = [], isLoading } = useFaultDataByDiagnosticId(
    dId,
    event.device.id,
    new Date(new Date().getTime() - FAULT_DETAIL_HISTORY),
    new Date(),
  );
  if (!dId) return <></>;
  const addIn = resolveDiagnosticOverride(descriptions, dId, deviceGroupIds);
  const currentDate = new Date();

  const differenceInMilliseconds = currentDate.getTime() - (event.dateTime?.getTime() ?? 0);

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h6">{diagnostic?.name}</Typography>
      <Typography variant="body1" mt={1}>
        {t("faultOverview.since") + " " + formatDuration(differenceInMilliseconds, true)}
      </Typography>
      <Typography>{addIn?.description ?? ""}</Typography>
      <Typography variant="h6" mt={2}>
        {t("faultOverview.instruction")}
      </Typography>
      <Typography>{addIn?.instruction ?? "---"}</Typography>
      <Typography variant="h6">{t("faultOverview.lastOccurences")}</Typography>
      <Box sx={{ width: "100%" }}>
        <FaultTable
          faultData={lastFaults}
          isLoading={isLoading}
          selectable={false}
          deviceGroupIds={deviceGroupIds}
        />
      </Box>
    </Box>
  );
};
